import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { ok } from "@nju/result";
import { fetchTranslations } from "../historyPaymentTranslations";
import { mergePaymentWithTranslations } from "../historyPaymentTranslations/mergePaymentWithTranslations";
import { IPaymentType, PaymentState } from "../types";
import { IPayment } from "../types";
import {
  IHistoryPayload,
  IHistoryResult,
  IHistoryWithTranslationsResult,
} from "./types";
import { serverResponse } from "./validators";

interface IFetchPaymentHistoryProps {
  page: number;
  paymentsPerPage: number;
  status?: IPayment["status"];
  payerId?: string;
  methodType?: PaymentState["type"];
  type?: IPaymentType[];
}

export async function fetchPaymentHistory({
  type,
  page,
  status,
  payerId,
  methodType,
  paymentsPerPage,
}: IFetchPaymentHistoryProps): Promise<IHistoryResult> {
  const payload: IHistoryPayload = {
    showEmail: false,
    perPage: paymentsPerPage,
    page,
    type,
    status,
    payerId,
    methodType,
  };

  const paymentHistoryResult = client(
    `${
      process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST || "unknown"
    }/payment/history`,
    {
      method: "post",
      validator: serverResponse,
      headers: {
        version: "2",
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
      },
      json: payload,
    },
  );

  const [result, translations] = await Promise.all([
    paymentHistoryResult,
    fetchTranslations(),
  ]);

  if (result.isError) {
    Bugsnag.notify(result.err);
    return result;
  }

  if (translations.isError) {
    Bugsnag.notify(translations.err);
    return translations;
  }

  return ok(result.value);
}

export async function fetchPaymentHistoryWithTranslations({
  page,
  paymentsPerPage,
}: IFetchPaymentHistoryProps): Promise<IHistoryWithTranslationsResult> {
  const payload: IHistoryPayload = {
    showEmail: false,
    perPage: paymentsPerPage,
    page,
    type: ["PAYMENT", "REFUND"],
  };

  const paymentHistoryResult = client(
    `${
      process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST || "unknown"
    }/payment/history`,
    {
      method: "post",
      validator: serverResponse,
      headers: {
        version: "2",
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
      },
      json: payload,
    },
  );

  const [result, translations] = await Promise.all([
    paymentHistoryResult,
    fetchTranslations(),
  ]);

  if (result.isError) {
    Bugsnag.notify(result.err);
    return result;
  }

  if (translations.isError) {
    Bugsnag.notify(translations.err);
    return translations;
  }

  return ok({
    ...result.value,
    payments: mergePaymentWithTranslations(
      result.value.payments,
      translations.value,
    ),
  });
}
